
import { Vue, Component, Watch, Prop, Model } from 'vue-property-decorator';

@Component({})
export default class DataChedField extends Vue {
  val = false;

  @Prop()
  readonly!: boolean;

  @Prop()
  disabled!: boolean;

  @Model('change', {
    type: String,
  })
  value!: string;

  @Watch('value')
  watchValue() {
    this.val = !!(this.value && this.value === '有');
  }

  mounted() {
    this.watchValue();
  }
}
